export enum PaymentType {
  NOT_PAID = 'NOT_PAID',
  ALREADY_PAID = 'ALREADY_PAID'
}

export enum InvoiceCategory {
  EXPENSE = 'EXPENSE',
  REVENUE = 'REVENUE'
}
export enum InvoiceStatus {
  PENDING = 'PENDING',
  PAID = 'PAID',
  CANCELLED = 'CANCELLED'
}
